export default "__VITE_ASSET__DZpswrfk__"